/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeDialogInputBoolean } from "../../d-dialog-input-boolean";
import { DThemeWhiteDialogInput } from "./d-theme-white-dialog-input";

export class DThemeWhiteDialogInputBoolean
	extends DThemeWhiteDialogInput
	implements DThemeDialogInputBoolean {}
